import { getDiscountDisplay } from './discountDisplay.js'

function numberOrNull(value) {
  if (!['number', 'string'].includes(typeof value) || String(value).trim() === '') return null
  const number = Number(value)
  return Number.isFinite(number) && number >= 0 ? number : null
}

// Use the outer sale unit: "3 Carton (30 packs)" means three cartons, not 30 packs.
export function resolveAustraliaPackUnits(label) {
  if (typeof label !== 'string') return null
  const match = label.trim().match(/^(\d+(?:,\d{3})*)\s*(cartons?|ctns?|pcs?|pieces?|packs?|packets?|boxes|box|sets?|条|條|件|支|个|個|包|盒|套)?(?=$|[\s(（/,-])/i)
  if (!match || (!match[2] && !/^\d+(?:,\d{3})*$/.test(label.trim()))) return null
  const quantity = Number(match[1].replace(/,/g, ''))
  if (!Number.isSafeInteger(quantity) || quantity <= 0) return null
  const unit = (match[2] || 'pc').toLowerCase()
  return {
    quantity,
    unit: /^(carton|ctn)|^[条條]$/.test(unit) ? 'carton'
      : /^(pack|packet)|^包$/.test(unit) ? 'pack'
        : /^box|^盒$/.test(unit) ? 'box'
          : /^set|^套$/.test(unit) ? 'set' : 'pc',
  }
}

export function getAustraliaDiscountUnitPrice({ price, quantity, unit = 'pc', item, comparePrice } = {}) {
  const amount = numberOrNull(price)
  const count = numberOrNull(quantity)
  if (amount === null || !Number.isSafeInteger(count) || count <= 0) return null
  const original = numberOrNull(comparePrice ?? item?.originalPrice ?? item?.marketPrice)
  const rate = numberOrNull(item?.discountRate)
  const hasDiscount = !!getDiscountDisplay(item)
    || (original !== null && original > amount)
    || (rate !== null && rate > 0 && rate < 1)
  if (!hasDiscount) return null
  // The current sale price already includes its discount. Never apply the badge text again.
  return { amount: amount / count, quantity: count, unit }
}

export function getAustraliaSkuDiscountUnitPrice({ sku, specs = [], selected = {}, price, comparePrice } = {}) {
  if (!sku) return null
  const ids = String(sku.spItemSkuSpecificationIds || '').split(',').map(id => id.trim()).filter(Boolean)
  if (ids.length && Object.entries(selected).some(([key, value]) => !ids.includes(`${key}-${value}`))) return null
  const packs = specs
    .filter(spec => /pack|size|pcs|quantity|数量|數量|规格|規格/i.test(spec.specName || '')
      && !/口味|flavou?r|colou?r|颜色|顏色/i.test(spec.specName || ''))
    .map(spec => {
      const option = spec.children?.find(value => String(value.id) === String(selected[spec.id]))
      const pack = resolveAustraliaPackUnits(option?.specName)
      return pack ? { ...pack, specId: spec.id } : null
    })
    .filter(Boolean)
  if (packs.length !== 1) return null
  const pack = packs[0]
  const result = getAustraliaDiscountUnitPrice({ price, quantity: pack.quantity, unit: pack.unit, item: sku, comparePrice })
  return result ? { ...result, specId: pack.specId } : null
}
